import { render, staticRenderFns } from "./MoreLicenseCardList.vue?vue&type=template&id=47be8e3c&scoped=true"
import script from "./MoreLicenseCardList.vue?vue&type=script&lang=js"
export * from "./MoreLicenseCardList.vue?vue&type=script&lang=js"
import style0 from "./MoreLicenseCardList.vue?vue&type=style&index=0&id=47be8e3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47be8e3c",
  null
  
)

export default component.exports